import React from 'react';
import { connect } from 'react-redux';

import BasePage from 'apps/auth/components/utils/BasePage';
import { OBJECT_TYPE_CONFIRM_CARD_WITH_AMOUNT } from 'apps/auth/constants/Constants';

import ConfirmAmount from './ConfirmAmount';
import ConfirmCode from './ConfirmCode';

const Confirm = (props) => {
    const isAmount = props.confirm_amount.confirmType === OBJECT_TYPE_CONFIRM_CARD_WITH_AMOUNT;

    return (
        <>
            {!props.loading && (
                <>
                    {isAmount && <ConfirmAmount />}
                    {!isAmount && <ConfirmCode />}
                </>
            )}
        </>
    );
};

const mapStateToProps = (state) => {
    return {
        confirm_amount: state.extra.confirm_amount,
    };
};
export default connect(mapStateToProps)(BasePage(Confirm));
